/**
 * CentralExchange - System to facilitate periodic, async data exchanges
 *  between the UI and the server.  This can be used to update secure
 *  message counts, warn the user of impending forced logout and offers
 *  the possibility of implementing chat in the future.
 */

// Variable so that other JS can test for existence of CentralExchange
ht.CentralExchange = true;

// The following is the list of topics that CentralExchange handles
ht._centralTopics = ht._centralTopics ? ht._centralTopics : {};
// Now create a class for handling CentralTopics
ht.CentralTopic = function (topicName, flags) {
  // if this is a new topic, create it
  if (!(topicName && ht._centralTopics[topicName])) {
    var callbacks = flags ? $.Callbacks(flags) : $.Callbacks();
    var topic = {
      subscribe: callbacks.add,
      publish: callbacks.fire,
      unsubscribe: callbacks.remove
    };
    ht._centralTopics[topicName] = topic;
  }
  return ht._centralTopics[topicName];
};

/** CentralData allows for variables to be shared across tabs/windows
 *  through the use of cookies and local variables.
 */
// List of local data known about
ht._centralData = ht._centralData ? ht._centralData : {};
// Now create the class for handling CentralData

if (!ht.support.localStorageEvent) {
  /***************************************************************************
   * NO localStorage
   **************************************************************************/
  ht.CentralData = function (dataName) {
    // If this is a new data field locally, then create the local instance
    var centralData = dataName && ht._centralData[dataName];
    if (!centralData) {
      var callbacks = $.Callbacks();
      centralData = {
        get: function () {
          return centralData.sync();
        },
        set: function (value) {
          return centralData.sync(value);
        },
        watch: callbacks.add,
        unwatch: callbacks.remove,
        del: function () {
          centralData._localData = null;
          $.cookies.del(dataName, centralData._cookieOpts);
          delete ht._centralData[dataName];
          callbacks.fire(null);
          callbacks.disable();
          return null;
        },
        sync: function (val) {
          var reqVal = val,
            locVal = centralData._localData;
          // we are setting the global value
          if (arguments.length == 1) {
            if (!centralData._valsEqual(reqVal, locVal)) {
              centralData._localData = val;
              centralData._setGlobal(val);
              callbacks.fire(val);
            }
          } else {
            var glob = centralData._getGlobal();
            if (glob === null) {
              // another tab or window deleted this
              centralData.del();
            } else if (!centralData._valsEqual(locVal, glob)) {
              // another tab or window changed this
              centralData._localData = glob;
              callbacks.fire(glob);
            }
          }
          return centralData._localData;
        },
        _cookieOpts: {secure: false},
        _getGlobal: function () {
          return $.cookies.get(dataName, centralData._cookieOpts);
        },
        _setGlobal: function (val) {
          $.cookies.set(dataName, val, centralData._cookieOpts);
        },
        _valsEqual: function (val1, val2) {
          val1 = typeof val1 !== 'string' ? JSON.stringify(val1) : val1;
          val2 = typeof val2 !== 'string' ? JSON.stringify(val2) : val2;
          return val1 == val2;
        },
        _localData: null
      };
      if (dataName) {
        ht._centralData[dataName] = centralData;
      }
    }
    return centralData;
  };
  ht.CentralDataManager = {
    defaultOpts: {
      updateIntervalMS: 1000
    },
    init: function (opts) {
      if (!ht.CentralDataManager.isInitialized) {
        ht.CentralDataManager.opts = $.extend(
          ht.CentralDataManager.defaultOpts,
          opts
        );
        ht.CentralDataManager._interval = window.setInterval(
          ht.CentralDataManager.syncData,
          ht.CentralDataManager.opts.updateIntervalMS
        );
        ht.CentralTopic('SessionPhase').subscribe(function (phaseName) {
          if (phaseName == 'Expired') {
            ht.CentralDataManager.shutdown();
          }
        });
        // Only initialize once
        ht.CentralDataManager.isInitialized = true;
      }
    },
    syncData: function () {
      for (toSync in ht._centralData) {
        ht._centralData[toSync].sync();
      }
    },
    shutdown: function () {
      window.clearInterval(ht.CentralDataManager._interval);
    },
    isInitialized: false
  };
} else {
  /***************************************************************************
   * localStorage AVAILABLE
   **************************************************************************/
  ht.CentralData = function (dataName) {
    if (!dataName) {
      return null;
    }
    // Namespace for centraldata
    var keyName = 'ht.CentralData.' + dataName;
    // If this is a new data field locally, then create the local instance
    var centralData = ht._centralData[dataName];
    if (!centralData) {
      var callbacks = $.Callbacks();
      centralData = {
        get: function () {
          return JSON.parse(localStorage.getItem(keyName));
        },
        set: function (value) {
          if (value == null) {
            centralData.del();
          } else {
            var reqVal = JSON.stringify(value);
            var curVal = localStorage.getItem(keyName);
            if (!centralData._valsEqual(reqVal, curVal)) {
              localStorage.setItem(keyName, reqVal);
              callbacks.fire(value);
            }
          }
          return value;
        },
        watch: callbacks.add,
        unwatch: callbacks.remove,
        del: function () {
          localStorage.removeItem(keyName);
          callbacks.fire(null);
          callbacks.disable();
          return null;
        },
        storageHandler: function (evt) {
          // handle a delete
          if (evt.newValue == null) {
            centralData.del();
          } else {
            callbacks.fire(JSON.parse(evt.newValue));
          }
        },
        _valsEqual: function (val1, val2) {
          val1 = typeof val1 !== 'string' ? JSON.stringify(val1) : val1;
          val2 = typeof val2 !== 'string' ? JSON.stringify(val2) : val2;
          return val1 == val2;
        }
      };
      ht._centralData[dataName] = centralData;
    }
    return centralData;
  };
  ht.CentralDataManager = {
    defaultOpts: {},
    init: function (opts) {
      if (!ht.CentralDataManager.isInitialized) {
        ht.CentralDataManager.opts = $.extend(
          ht.CentralDataManager.defaultOpts,
          opts
        );
        window.addEventListener(
          'storage',
          ht.CentralDataManager.handleStorageEvt,
          false
        );
        ht.CentralTopic('SessionPhase').subscribe(function (phaseName) {
          if (phaseName == 'Expired') {
            ht.CentralDataManager.shutdown();
          }
        });
        // Only initialize once
        ht.CentralDataManager.isInitialized = true;
      }
    },
    handleStorageEvt: function (evt) {
      evt = evt || window.event;
      if (evt.key.indexOf('ht.CentralData.') == 0) {
        // This is a CentralData event
        var dataName = evt.key.slice('ht.CentralData.'.length);
        if (ht._centralData[dataName] != null) {
          ht._centralData[dataName].storageHandler(evt);
        }
      }
    },
    shutdown: function () {
      for (toSync in ht._centralData) {
        ht._centralData[toSync].del();
      }
    },
    isInitialized: false
  };
}
/***************************************************************************
 * END OF localStorage AVAILABLE
 **************************************************************************/

// uses CentralData to collaborate between tabs/windows for proper session mgmt
ht.CentralSessionManager = {
  defaultOpts: {
    expireSecs: 1200,
    warnBeforeSecs: 300,
    checkIntervalSecs: 60,
    forceLogout: true,
    renewSessionUrl: false,
    logoutLocation: '/app/index.page?logout=1'
  },
  init: function (opts) {
    if (!ht.CentralSessionManager.isInitialized) {
      ht.CentralSessionManager.isHalted = false;
      ht.CentralTopic('HaltSessionHandling', 'memory').subscribe(
        ht.CentralSessionManager.halt
      );
      ht.CentralSessionManager.opts = $.extend(
        ht.CentralSessionManager.defaultOpts,
        opts
      );
      ht.CentralSessionManager.opts.sessionId = ht.xsesschk
        ? ht.xsesschk
        : 'ext' + Math.floor(Math.random() * 10000);
      ht.CentralSessionManager.phaseName = 'CSMP';
      ht.CentralSessionManager.timeName = 'CSMT';
      // start off with fresh session
      ht.CentralData(ht.CentralSessionManager.phaseName).set('Normal');
      ht.CentralData(ht.CentralSessionManager.phaseName).watch(
        ht.CentralSessionManager.watchPhase
      );
      // must explicitly set this if we are not using cookies for medium
      if (ht.support.localStorageEvent) {
        ht.CentralData('JSESSIONID').set($.cookies.get('JSESSIONID'));
      }
      ht.CentralData('JSESSIONID').watch(ht.CentralSessionManager.checkPhase);
      ht.CentralTopic('RenewSession').subscribe(
        ht.CentralSessionManager.renewSession
      );
      ht.CentralSessionManager.renewSession();

      ht.CentralSessionManager._interval = window.setInterval(
        ht.CentralSessionManager.checkPhase,
        ht.CentralSessionManager.opts.checkIntervalSecs * 1000
      );
      // Only initialize once
      ht.CentralSessionManager.isInitialized = true;
    }
  },
  checkPhase: function () {
    // only take action if the we are not halted
    if (!ht.CentralSessionManager.isHalted) {
      // check that the session cookie matches that of this page (when not external)
      if (!/^ext/.test(ht.CentralSessionManager.opts.sessionId)) {
        var sessIdCookie = $.cookies.get('JSESSIONID') || '';
        if (sessIdCookie != ht.CentralSessionManager.opts.sessionId) {
          ht.CentralSessionManager.setPhase('Expired');
          return ht.CentralData(ht.CentralSessionManager.phaseName).get();
        }
      }
      // get times
      var curTime = $.now(),
        baseTime = ht.CentralData(ht.CentralSessionManager.timeName).get();
      if (
        curTime >
          (ht.CentralSessionManager.opts.expireSecs -
            ht.CentralSessionManager.opts.warnBeforeSecs) *
            1000 +
            baseTime &&
        curTime < ht.CentralSessionManager.opts.expireSecs * 1000 + baseTime
      ) {
        // publish that this session will expire soon if needed
        ht.CentralSessionManager.setPhase('Warning');
      } else if (
        curTime >
        ht.CentralSessionManager.opts.expireSecs * 1000 + baseTime
      ) {
        // if past expected expiration time, then expire the session
        ht.CentralSessionManager.setPhase('Expired');
      } else {
        ht.CentralSessionManager.setPhase('Normal');
      }
      return ht.CentralData(ht.CentralSessionManager.phaseName).get();
    } else {
      return null;
    }
  },
  setPhase: function (phaseName) {
    var existing = ht.CentralData(ht.CentralSessionManager.phaseName).get();
    if (existing != 'Expired') {
      ht.CentralData(ht.CentralSessionManager.phaseName).set(phaseName);
    }
    return ht.CentralData(ht.CentralSessionManager.phaseName).get();
  },
  watchPhase: function (phaseName) {
    if (phaseName == 'Expired') {
      ht.CentralSessionManager.expireSession();
    }
    ht.CentralTopic('SessionPhase').publish(phaseName);
  },
  expireSession: function () {
    // only take action if the we are not halted
    if (!ht.CentralSessionManager.isHalted) {
      // The logic for this is to use the logout URL always.
      // If forceLogout is true, navigate there, else AJAX the url.
      window.clearInterval(ht.CentralSessionManager._interval);
      ht.CentralData(ht.CentralSessionManager.timeName).set(1);
      if (ht.CentralSessionManager.opts.forceLogout) {
        window.location = ht.CentralSessionManager.opts.logoutLocation;
      } else {
        var opts = ht.getAjaxBaseOpts({
          url: ht.CentralSessionManager.opts.logoutLocation,
          success: function () {
            $.noop();
          },
          error: function () {
            $.noop();
          }
        });
        $.ajax(opts);
      }
    }
  },
  renewSession: function (doSessionRequest) {
    if (doSessionRequest == undefined || typeof doSessionRequest != 'boolean') {
      doSessionRequest = true;
    }
    if (ht.CentralSessionManager.opts.renewSessionUrl && doSessionRequest) {
      var opts = ht.getAjaxBaseOpts({
        url: ht.CentralSessionManager.opts.renewSessionUrl,
        success: function () {
          $.noop();
        },
        error: function () {
          $.noop();
        }
      });
      $.ajax(opts);
    }
    ht.CentralData(ht.CentralSessionManager.timeName).set($.now());
    return ht.CentralSessionManager.checkPhase();
  },
  halt: function () {
    ht.CentralSessionManager.isHalted = true;
  }
};

// Uses ajax call in combination with CentralData to keep track of secure message counts
ht.CentralMessagingManager = {
  defaultOpts: {
    checkIntervalSecs: 120,
    exchangeDataUrl: '/app/uipeer/getMsgCount',
    messageKey: false
  },
  init: function (opts) {
    if (!ht.CentralMessagingManager.isInitialized) {
      ht.CentralMessagingManager.opts = $.extend(
        ht.CentralMessagingManager.defaultOpts,
        opts
      );
      ht.CentralMessagingManager.opts.sessionId = ht.xsesschk
        ? ht.xsesschk
        : 'ext' + Math.floor(Math.random() * 10000);
      ht.CentralMessagingManager.checkMessages();
      ht.CentralData(ht.CentralMessagingManager.messagingContainer).watch(
        ht.CentralMessagingManager.watchMessages
      );
      ht.CentralTopic('CheckMessages').subscribe(
        ht.CentralMessagingManager.checkMessages
      );
      ht.CentralTopic('SessionPhase').subscribe(function (phaseName) {
        if (phaseName == 'Expired') {
          ht.CentralMessagingManager.shutdown();
        }
      });

      // Only initialize once
      ht.CentralMessagingManager.isInitialized = true;
    }
  },
  messagingFlags: 'memory',
  shutdown: function () {
    window.clearTimeout(ht.CentralMessagingManager._timeout);
  },
  checkMessages: function (forceNewCheck) {
    if (
      forceNewCheck != undefined &&
      typeof forceNewCheck == 'boolean' &&
      forceNewCheck
    ) {
      // set the value to an empty string to force a new value and not delete the watch queue
      ht.CentralData(ht.CentralMessagingManager.messagingContainer).set('');
    }
    var currentMessages = ht
      .CentralData(ht.CentralMessagingManager.messagingContainer)
      .get();
    // Check for change in messages if currentMessages is not set, if the key doesn't match or if
    //  the time of the next check is past due
    if (
      currentMessages == null ||
      currentMessages == '' ||
      currentMessages.msgKey != ht.CentralMessagingManager.opts.messageKey ||
      $.now() >
        currentMessages.time +
          ht.CentralMessagingManager.opts.checkIntervalSecs * 1000
    ) {
      ht.CentralMessagingManager.fetchMessages();
    } else {
      // watch because if this is the first time through, there may be no change, but need to update
      ht.CentralMessagingManager.watchMessages(currentMessages);
      ht.CentralMessagingManager._timeout = window.setTimeout(
        ht.CentralMessagingManager.checkMessages,
        ht.CentralMessagingManager.opts.checkIntervalSecs * 1000
      );
    }
  },
  fetchMessages: function () {
    if (ht.CentralMessagingManager.opts.messageKey != false) {
      var opts = ht.getAjaxBaseOpts({
        dataType: 'json',
        url: ht.CentralMessagingManager.opts.exchangeDataUrl,
        success: ht.CentralMessagingManager.updateMessages
      });
      $.ajax(opts);
    }
  },
  updateMessages: function (data) {
    if (data != null && data.secureMessage != null) {
      var msg = data.secureMessage;
      if (
        msg.msgKey == ht.CentralMessagingManager.opts.messageKey &&
        msg.unread != null
      ) {
        var newMsg = {msgKey: msg.msgKey, unread: msg.unread, time: $.now()};
        ht.CentralData(ht.CentralMessagingManager.messagingContainer).set(
          newMsg
        );
      }
    }
    ht.CentralMessagingManager._timeout = window.setTimeout(
      ht.CentralMessagingManager.checkMessages,
      ht.CentralMessagingManager.opts.checkIntervalSecs * 1000
    );
  },
  watchMessages: function (messages) {
    if (
      messages != null &&
      messages.msgKey == ht.CentralMessagingManager.opts.messageKey &&
      messages.unread != null
    ) {
      ht.CentralTopic(
        'UnreadSecureMessageCount',
        ht.CentralMessagingManager.messagingFlags
      ).publish(messages.unread);
    }
  },
  messagingContainer: 'CMC'
};
